import React from "react";
import { Box, Flex, Text } from "rebass";
import { Field, Form } from "formik";
import { fields, FormTypes } from "./formSettings";

import { Input } from "../components/Input";
import { SubmitButton } from "../components/SubmitButton";

export const FormComponent: React.FC<FormTypes> = ({ isSubmitting, isValid }) => (
  <Flex
    height="100%"
    flexDirection="column"
    p="65px 100px 35px"
  >
    <Text
      as="h3"
      fontSize="30px"
      fontWeight="bold"
      lineHeight={1.07}
      color="#2b3160"
    >
      Account Data
    </Text>

    <Box
      flex={1}
      mt="30px"
    >
      <Form style={{ height: "100%" }}>
        <Box>
          {
            fields.map(({ name, placeholder, type }) => (
              <Field
                key={name}
                name={name}
                type={type}
                placeholder={placeholder}
                component={Input}
              />
            ))
          }
        </Box>

        <Box
          mt="20px"
          fontSize="14px"
        >
          <SubmitButton disabled={isSubmitting || !isValid}>
            update
          </SubmitButton>
        </Box>
      </Form>
    </Box>
  </Flex>
);
